import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import React, { Component } from 'react';
import Link from 'react-router/es/Link';
import { bindActionCreators } from 'redux';
import CustomIcon from '../../common/CustomIcon';
import UserImage from '../../common/UserImage';
import * as drawerActions from '../../../actions/drawerActions';
import * as discussionActions from '../../../actions/discussionActions';
import * as discussionDrawerActions from '../../../actions/discussionDrawerActions';
import { isFuture, isPast } from '../../../utils/dateUtlis';
import { ROUTES, ROLE, DRAWER_CONTENTS, GROUPS as CONSTS } from '../../../const';
import { MODES } from '../../drawer-contents/AssignmentsContentPanel/assignmentsContentPanelService';
import { capitalize } from '../../../utils/stringUtils';
import { AccentCard, Badge, DropdownOptions } from '@netexknowledge/smart-components';
import { API_CLASSROOMS_BOOKS, API_CONTENT_BY_ACTIVITY_ID } from '../../../services/api/apiConst';
import * as discussionApi from '../../../services/api/discussionApi';
import axios from 'axios';
import * as bookActions from '../../../actions/bookActions';
import { DISCUSSION_TYPE_NEUTRAL, getDiscussionTypeMeta } from './discussionTypeMeta';
import { getDiscussionAccentColor, isDueSoon, DISCUSSION_STATE_COLOR } from './discussionStateColors';

const relativeTime = require('dayjs/plugin/relativeTime');
const calendar = require('dayjs/plugin/calendar');

dayjs.extend(relativeTime);
dayjs.extend(calendar);

class DiscussionCard extends Component {
  componentDidMount() {
    const { discussion, classroom } = this.props;
    const isClassroomDiscussion = !discussion.activityContext;
    this.setState({ isClassroomDiscussion });

    const fetchContent = async () => {
      if (!isClassroomDiscussion) {
        const content = await discussionApi.getUnitAndLessonContentDiscussion(discussion, classroom);
        this.setState({
          unitTitle: content.unitTitle,
          lessonTitle: content.lessonTitle,
          unit: content.unit,
          lesson: content.lesson
        });
        const book = await discussionApi.getDiscussionContentBook(discussion, classroom);
        this.setState({
          book: book
        });
      }
    };

    fetchContent();
  }

  launchSmartContentHandler = e => {
    const { bookActions, account, institution, classroom, discussion } = this.props;
    const { unit, lesson, book } = this.state;
    e.preventDefault();

    bookActions.openResource({
      book,
      unit: unit,
      lesson: lesson,
      account,
      institution,
      classroom,
      questionActivityId: discussion.activityContext.activityId
    });
  };

  constructor(props) {
    super(props);
    this.state = {
      unitTitle: '',
      lessonTitle: '',
      isClassroomDiscussion: false
    };
    this.openEditDiscussionPanel = this.openEditDiscussionPanel.bind(this);
  }

  static propTypes = {
    user: PropTypes.object,
    discussion: PropTypes.object,
    routerParams: PropTypes.object,
    drawerActions: PropTypes.object,
    discussionActions: PropTypes.object,
    discussionDrawerActions: PropTypes.object,
    account: PropTypes.object,
    classroom: PropTypes.object,
    institution: PropTypes.object
  };
  openEditDiscussionPanel() {
    const { drawerActions, discussionDrawerActions, discussion } = this.props;
    discussionDrawerActions.setSelectedGroup(CONSTS.EVERYONE);
    discussionDrawerActions.setTitle(discussion.title);
    discussionDrawerActions.setDescription(discussion.description);
    discussionDrawerActions.setDiscussionId(discussion.id);
    discussionDrawerActions.setStartDate(discussion.startDate);
    discussionDrawerActions.setDueDate(discussion.dueDate);
    discussionDrawerActions.setMode(MODES.EDIT);
    drawerActions.openDrawerAndSetContent(DRAWER_CONTENTS.CREATE_DISCUSSIONS_PANEL);
  }

  openDiscussionCloseModal = () => {
    const { discussionActions, discussion } = this.props;
    discussionActions.setCloseDiscussionRevealOpen();
    discussionActions.setCloseDiscussionRevealData(discussion);
  };

  openDiscussionRemoveModal = () => {
    const { discussionActions, discussion } = this.props;
    discussionActions.setRemoveDiscussionRevealOpen();
    discussionActions.setRemoveDiscussionRevealData(discussion);
  };

  getDropdownOptions() {
    const { discussion } = this.props;

    let optionItems = [];
    if (isFuture(discussion.dueDate)) {
      optionItems.push({
        key: 1,
        text: I18n.t('discussions.common.options.edit'),
        onClick: this.openEditDiscussionPanel,
        icon: 'custom-icons-edit-pencil',
        disabled: false
      });
      if (!isFuture(discussion.startDate)) {
        optionItems.push({
          key: 2,
          text: I18n.t('discussions.common.options.closeDiscussion'),
          onClick: this.openDiscussionCloseModal,
          icon: 'custom-icons-finish-flag',
          disabled: false
        });
      }
    }
    optionItems.push({
      key: 3,
      text: I18n.t('discussions.common.options.delete'),
      onClick: this.openDiscussionRemoveModal,
      icon: 'custom-icons-waste-can',
      disabled: false
    });
    return optionItems;
  }

  isUrl = word => {
    const regexUrl = /^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/g;
    return regexUrl.test(word);
  };

  printUrl = link => {
    return (
      <a style={{ cursor: 'pointer' }} href={link} target="_blank">
        {`${link} `}
      </a>
    );
  };

  renderDiscussionDescription = messageContent => {
    return (
      <>
        {messageContent &&
          messageContent
            .split('\n')
            .map(line => line.split(' ').map(word => (this.isUrl(word) ? this.printUrl(word) : `${word} `)))
            .map(line => <div>{line}</div>)}
      </>
    );
  };

  isTeacher = () => this.props.role === ROLE.INSTRUCTOR;

  render() {
    const { discussion, routerParams } = this.props;
    const { isClassroomDiscussion } = this.state;

    const meta = getDiscussionTypeMeta(discussion);
    const accentColor = getDiscussionAccentColor(discussion);
    const isScheduled = isClassroomDiscussion && isFuture(discussion.startDate);
    const isClosed = isClassroomDiscussion && isPast(discussion.dueDate);
    const isSoon = isClassroomDiscussion && !isScheduled && !isClosed && isDueSoon(discussion.dueDate);

    return (
      <AccentCard accentColor={accentColor} className="discussion-card">
        <div className="discussion-type-row">
          <CustomIcon name={meta.icon} size={15} color={DISCUSSION_TYPE_NEUTRAL.iconColor} />
          <span className="discussion-type-label" style={{ color: DISCUSSION_TYPE_NEUTRAL.textColor }}>
            {I18n.t(meta.labelKey)}
          </span>
          {isScheduled && (
            <Badge label={I18n.t('discussions.common.scheduled')} background="#fffae4" textColor="#666" />
          )}
          {isClosed && <Badge label={I18n.t('discussions.common.closedBadge')} background="#fee7e7" textColor="#a5323f" />}
          <span className="discussion-type-row-spacer" />
          {isClassroomDiscussion && this.isTeacher() && (
            <DropdownOptions
              id={'discussion-dropdown'}
              color="gray"
              dropdownSide="left"
              options={this.getDropdownOptions()}
            />
          )}
        </div>
        <div className="top-row">
          {isClassroomDiscussion ? (
            <>
              <UserImage picture={discussion.author.picture} classes={'xs'} />
              <span className="discussion-creation-info">
                <div className="teacher-name">{`${discussion.author.name} ${discussion.author.surname} `}</div>
                <div className="start-date">·</div>
                <div className="start-date">{capitalize(dayjs(discussion.startDate).fromNow())}</div>
              </span>
            </>
          ) : (
            <div className="discussion-type-info">
              <div className="discussion-type-icon">
                <CustomIcon name="workspace" size={18} color={DISCUSSION_TYPE_NEUTRAL.textColor} />
              </div>
              {this.state.unitTitle ? (
                <span>{this.state.unitTitle}</span>
              ) : (
                <span className="animated-background" style={{ width: '160px', height: '14px' }} />
              )}
            </div>
          )}
        </div>
        <div className="discussion-info">
          {isClassroomDiscussion ? (
            <>
              <span className="discussion-title">{discussion.title}</span>
              <span className="discussion-description">{this.renderDiscussionDescription(discussion.description)}</span>
            </>
          ) : (
            <span className="discussion-title">
              {this.state.lessonTitle || (
                <span className="animated-background" style={{ width: '60%', height: '20px' }} />
              )}
            </span>
          )}
        </div>
        <div className="discussion-metadata-row">
          {!isScheduled && (
            <span className="discussion-posts-views">
              {discussion.visits}{' '}
              {discussion.visits === 1 ? I18n.t('discussions.common.visit') : I18n.t('discussions.common.visits')}
            </span>
          )}
          {isClassroomDiscussion && (
            <span className={`discussion-due-date ${isSoon ? 'due-soon' : ''}`}>
              <CustomIcon name="finish-flag" size={13} color={isSoon ? DISCUSSION_STATE_COLOR.dueSoon : '#999'} />
              <span>{dayjs(isScheduled ? discussion.startDate : discussion.dueDate).calendar()}</span>
            </span>
          )}
          {!isScheduled && discussion.lastMessage && (
            <span className="last-comment-block">
              <span className="last-comment">{I18n.t('discussions.common.lastComment')}</span>
              <span className="last-comment-user">{discussion.lastMessage.author.name}</span>
              <span className="last-comment-since">· ({dayjs(discussion.lastMessage.timestamp).fromNow()})</span>
            </span>
          )}
          <span className="discussion-metadata-row-spacer" />
          {isClassroomDiscussion ? (
            isScheduled ? (
              <span className="right-side disabled">
                <CustomIcon name="chat-speech-balloon" size={15} />
                <span>
                  {I18n.t('discussions.common.reply')} (0)
                </span>
              </span>
            ) : (
              <Link className="right-side" to={`${ROUTES.CLASSROOM}/${routerParams.idClassroom}/discussions/${discussion.id}`}>
                <CustomIcon name="chat-speech-balloon" size={15} />
                <span>
                  {I18n.t('discussions.common.reply')} ({discussion.countMessages})
                </span>
              </Link>
            )
          ) : (
            <span className="right-side" onClick={this.launchSmartContentHandler}>
              <CustomIcon name="no-interactive" size={15} />
              <span>
                {I18n.t('discussions.common.openContent')} ({discussion.countMessages})
              </span>
            </span>
          )}
        </div>
      </AccentCard>
    );
  }
}

function mapStateToProps(state) {
  return {
    routerParams: state.router.params,
    user: state.account.user,
    role: state.classrooms.selectedClassroom.classroom.role,
    account: state.account,
    institution: state.school.school
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookActions: bindActionCreators(bookActions, dispatch),
    discussionDrawerActions: bindActionCreators(discussionDrawerActions, dispatch),
    discussionActions: bindActionCreators(discussionActions, dispatch),
    drawerActions: bindActionCreators(drawerActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DiscussionCard);
